const POST_LOGIN_PATH_KEY = "galileo.office.postLoginPath";

function routerBasename(): string {
    return String(import.meta.env.BASE_URL ?? "/").replace(/\/$/, "");
}

/** Convert a full window path into a React Router path (basename stripped). */
export function toRouterPath(absolutePath: string): string {
    const base = routerBasename();
    let path = absolutePath.trim();
    if (base !== "" && path.startsWith(base)) {
        path = path.slice(base.length);
    }
    if (path === "" || path === "/") return "/";
    return path.startsWith("/") ? path : `/${path}`;
}

/** Paths that non-Editors may be returned to after sign-in. */
export function isFloorplanPath(path: string): boolean {
    const normalized = toRouterPath(path).split("?")[0] ?? "";
    return normalized === "/admin/floorplan" || normalized.startsWith("/admin/floorplan/");
}

/**
 * Remember the current URL before MSAL redirect so we can restore
 * floor-plan deep links for non-Editor users after sign-in.
 */
export function rememberPostLoginPath(
    path: string = window.location.pathname + window.location.search,
): void {
    const routerPath = toRouterPath(path);
    if (routerPath === "/" ) return;
    try {
        sessionStorage.setItem(POST_LOGIN_PATH_KEY, routerPath);
    } catch {
        /* private mode / quota — ignore */
    }
}

export function consumePostLoginPath(): string | null {
    try {
        const value = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
        sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
        return value;
    } catch {
        return null;
    }
}
